import React from 'react'
import './styles'

# components
import Pager      from '/components/pager/history-pager'
import Spinner    from '/components/spinner'
import List       from '/components/list'
import Filters    from '/components/filters'
import Datetime   from '/components/datetime'
import ModalState from '/components/modal-state'
import Modal      from 'react-bootstrap/lib/Modal'
import flash      from '/lib/flash'

import FaPlus   from 'react-icons/lib/fa/plus'
import FaTrash  from 'react-icons/lib/fa/trash'

import Can               from '/components/can'
import ChannelPartnerForm from './form'

import {
  withChannelPartners
  withCreateChannelPartner
  withUpdateChannelPartner
  withDeleteChannelPartner
} from './queries'

export default \
withChannelPartners \
withCreateChannelPartner \
withUpdateChannelPartner \
withDeleteChannelPartner \
class ChannelPartners extends React.Component
  constructor: ->
    super arguments...
    @state =
      modalOpen: false
      disabled: false

  toggle: =>
    @setState modalOpen: not @state.modalOpen

  channelPartnerCreate: (channelPartner)=>
    {name, tm_identifier, note} = channelPartner
    unless name and tm_identifier
      flash.warning 'Name and TM Identifier are required.'
      return {}
    @setState disabled: true
    {channel_partner, errors} = await @props.createChannelPartner {name, tm_identifier, note}
    if errors?.length
      flash.error errors
    else
      flash.success "Channel partner created"
      @props.channelPartnersRefetch()
    @setState disabled: false
    {channel_partner, errors}

  channelPartnerUpdate: (channelPartner)=>
    {id, name, tm_identifier, note} = channelPartner
    unless name and tm_identifier
      flash.warning 'Name and TM Identifier are required.'
      return {}
    @setState disabled: true
    {channel_partner, errors} = await @props.updateChannelPartner id, {name, tm_identifier, note}
    if errors?.length
      flash.error errors
    else
      flash.success "Channel partner saved"
      @props.channelPartnersRefetch()
    @setState disabled: false
    {channel_partner, errors}

  deleteChannelPartner: (channelPartner)=>
    return unless confirm "Are you sure you want to delete #{channelPartner.name}?"
    {errors} = await @props.deleteChannelPartner channelPartner.id
    if errors?.length
      flash.error errors
    else
      flash.success "Channel partner deleted"
      @props.channelPartnersRefetch()

  render: ->
    <div className="ChannelPartners">
      <header>
        <h1>Channel Partners</h1>
        {@newChannelPartner()}
      </header>
      <section className="content">
        {@filters()}
        {@list()}
        {@pager()}
      </section>
    </div>

  newChannelPartner: ->
    <Can action='manage' subject='ChannelPartner'>
      <span>
        <button className='btn btn-default' onClick={@toggle}>
          <FaPlus/>
          {' '}
          New Channel Partner
        </button>
        <Modal
          show={@state.modalOpen}
          onHide={@toggle}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Create a new channel partner
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='clearfix'>
            <ChannelPartnerForm
              save={@channelPartnerCreate}
              cancel={@toggle}
              disabled={@state.disabled}
            />
          </Modal.Body>
        </Modal>
      </span>
    </Can>

  filters: ->
    <Filters>
      <Filters.Search />
      <span className="pull-right">
        <Pager meta={@props.channelPartnersPagination} buffer={2}/>
      </span>
    </Filters>

  list: ->
    return <Spinner/> if @props.channelPartnersLoading
    <List>
      {@header()}
      {for channelPartner in @props.channelPartners
        <List.Row key={channelPartner._key}>
          <List.Cell className="id" title={channelPartner.id}>
            {channelPartner.id}
          </List.Cell>
          <List.Cell className="name">
            {channelPartner.name}
          </List.Cell>
          <List.Cell className="tm-identifier">
            <code>{channelPartner.tm_identifier}</code>
          </List.Cell>
          <List.Cell className="note">
            {channelPartner.note}
          </List.Cell>
          <List.Cell className="created-at">
            <Datetime date={channelPartner.created_at}/>
          </List.Cell>
          <Can action='manage' subject='ChannelPartner'>
            <List.Cell className="actions">
              {@editModal channelPartner}
              {' '}
              <button
                className="btn btn-danger btn-sm"
                onClick={@deleteChannelPartner.bind @, channelPartner}
              ><FaTrash/></button>
            </List.Cell>
          </Can>
        </List.Row>
      }
    </List>

  header: ->
    <List.HeaderRow>
      <List.Header className="id">ID</List.Header>
      <List.Header className="name">Name</List.Header>
      <List.Header className="tm-identifier">TM Identifier</List.Header>
      <List.Header className="note">Note</List.Header>
      <List.Header className="created-at">Created</List.Header>
      <Can action='manage' subject='ChannelPartner'>
        <List.Header className="actions"></List.Header>
      </Can>
    </List.HeaderRow>

  pager: ->
    <div className="text-center">
      <Pager meta={@props.channelPartnersPagination} buffer={4}/>
    </div>

  editModal: (channelPartner)->
    <ModalState
      render={({open, toggle})=>
        <span>
          <button
            className="btn btn-default btn-sm"
            onClick={toggle}
          >
            Edit
          </button>

          <Modal
            show={open}
            onHide={toggle}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Edit Channel Partner
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className='clearfix'>
              <ChannelPartnerForm
                save={@channelPartnerUpdate}
                cancel={toggle}
                channel_partner={channelPartner}
                disabled={@state.disabled}
              />
            </Modal.Body>
          </Modal>
        </span>
      }/>
